import { render, staticRenderFns } from "./parameterPopup.vue?vue&type=template&id=2035ae00&scoped=true&"
import script from "./parameterPopup.vue?vue&type=script&lang=js&"
export * from "./parameterPopup.vue?vue&type=script&lang=js&"
import style0 from "./parameterPopup.vue?vue&type=style&index=0&id=2035ae00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035ae00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2035ae00')) {
      api.createRecord('2035ae00', component.options)
    } else {
      api.reload('2035ae00', component.options)
    }
    module.hot.accept("./parameterPopup.vue?vue&type=template&id=2035ae00&scoped=true&", function () {
      api.rerender('2035ae00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/surveyQquestionnaire/components/parameterPopup.vue"
export default component.exports